import { Box } from '@mui/material'
import React from 'react'
import theme from '../../../theme'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt'
import SchoolIcon from '@mui/icons-material/School'
import PollIcon from '@mui/icons-material/Poll'
import QuizIcon from '@mui/icons-material/Quiz'
import { StyledHeader, StyledText } from '../styles'

import { PreviewInfoPageDescriptions, PreviewInfoPageHeaders, PreviewInfoPageSteps } from '../constants'

interface PreviewInfoPageProps {
  step: number
}

export const PreviewInfoPage: React.FC<PreviewInfoPageProps> = ({ step }): JSX.Element => {
  const numOfInfoPages = Object.keys(PreviewInfoPageSteps).filter(key => isNaN(Number(key))).length
  const iconProp = { fontSize: 'inherit' }
  const icon = [
    <PersonAddAltIcon sx={iconProp} key='person-add-icon' />,
    <SchoolIcon sx={iconProp} key='term-icon' />,
    <QuizIcon sx={iconProp} key='survey-template-icon' />,
    <PollIcon sx={iconProp} key='survey-project-icon' />
  ]

  if (step < 0 || step > numOfInfoPages) return <></>
  return (
    <Box
      flexGrow='1'
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      m={theme.spacing(2)}
    >
      <StyledHeader fontSize={theme.spacing(6)}>{PreviewInfoPageHeaders[step]}</StyledHeader>

      <Box fontSize={theme.spacing(60)} display='flex' justifyContent='center' alignItems='center'>
        {icon[step - 1]}
      </Box>

      <StyledText textAlign='center' pl={theme.spacing(30)} pr={theme.spacing(30)}>{PreviewInfoPageDescriptions[step]}</StyledText>
    </Box>
  )
}
